import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Image, Card } from 'react-bootstrap'; // Added Row and Card
import '../css/LandingPage.css'; // Keep custom CSS for layout adjustments
import { useAuth } from '../api/auth/store';
import GeneratePage from './GeneratePage';
import { redirectLogin } from '../utils/session';


const LandingPage: React.FC = () => {
    const { isLogin, init } = useAuth(state => state)
    const [isInit, setInit] = useState(false)
    useEffect(() => {
        init().finally( () => setInit(true))
    })

    if (!isInit) return <></>

    if (isLogin) {
        return <GeneratePage />
    }

    const handleSignInRedirect = () => {
        // Redirect to the path that initiates the Passport SSO flow
        redirectLogin()
    };

    return (
        // Center the card vertically and horizontally within the viewport
        <Container fluid className="landing-container vh-100 d-flex justify-content-center align-items-center p-0">
            <Card style={{ width: '80%', maxWidth: '1200px', minHeight: '60vh' }}> {/* Added minHeight */}
                <Card.Body className="p-0 d-flex"> {/* Remove Card.Body padding, add d-flex to make Row fill height */}
                    <Row className="g-0 flex-grow-1"> {/* Use Row for columns, g-0 removes gutters, flex-grow-1 makes Row fill Card.Body */}
                        {/* Advertisement Column */}
                        <Col md={6} className="landing-advertisement d-flex flex-column justify-content-center align-items-center p-4">
                            <h2 className="mb-4">Welcome to Cocree</h2>
                            <Image src="https://via.placeholder.com/400x300?text=Ad+Image+1" alt="Advertisement 1" fluid rounded className="mb-3 landing-ad-image" />
                            <Image src="https://via.placeholder.com/400x300?text=Ad+Image+2" alt="Advertisement 2" fluid rounded className="landing-ad-image" />
                        </Col>

                        {/* Sign In Column */}
                        <Col md={6} className="landing-signin d-flex flex-column justify-content-center align-items-center p-4 text-center">
                            <p className="mb-4">Click below to sign in using Single Sign-On.</p>
                            <Button variant="primary" size="lg" onClick={handleSignInRedirect} className="mb-3">
                                Sign In with CPass
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default LandingPage;
